import { compose, filter, flatten, isFunction, join, map } from 'lodash/fp';
import { createGlobalStyle } from 'styled-components';
import { Card } from '@mews-commander/ui';
import { generateCssSpacings, mapIndexed } from '@mews-commander/utils';
import { getSpacingToken, getTextTokenPreset, getTypographyColor, Card as MewsUiCard } from '@optimus-web/core';
import { ButtonElement } from '@optimus-web/core/src/Button/style';
import { LinkStyled } from '@optimus-web/core/src/Link/style';

const joinLines = join('');

const stringifyRules = (styledElement: $TSFixMe, props = {}) =>
    compose(
        joinLines,
        filter((r) => !!r),
        flatten,
        map((r) => {
            if (isFunction(r)) {
                return r(props);
            }

            return r;
        })
    )(styledElement.componentStyle.rules);

const generateButtonStyles = (theme: $TSFixMe) => {
    const mapClassNamesToVariant = {
        'btn-default': 'tertiary',
        'btn-primary': 'primary',
        'btn-success': 'tertiary',
        'btn-info': 'ghost',
        'btn-danger': 'destructive',
    };
    const stringifyButton = mapIndexed(
        (variant: $TSFixMe, className: $TSFixMe) => `
            .${className}, .${className}:active:focus, .${className}:active:hover {
                ${stringifyRules(ButtonElement, {
                    variant: variant !== 'default' ? variant : undefined,
                    size: 'small',
                    theme,
                })}
                display: inline-block;
                line-height: 28px;
                box-shadow: none;
            }
        `
    );
    // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
    return compose(joinLines, stringifyButton)(mapClassNamesToVariant);
};
const globalStyles = createGlobalStyle`
    h3 {
        ${getTextTokenPreset('titleMedium')};
        color: ${getTypographyColor};
        margin-top: ${getSpacingToken('200')}px;
        margin-bottom: ${getSpacingToken('100')}px;
    }

    h4 {
        ${getTextTokenPreset('titleSmallStrong')};
        color: ${getTypographyColor};
        margin-top: ${getSpacingToken('100')}px;
        margin-bottom: ${getSpacingToken('100')}px;
    }

    a {
        ${(props) => stringifyRules(LinkStyled, { theme: props.theme, size: 'small', inherit: true, underline: true })}
    }

    .card {
        ${(props) => stringifyRules(MewsUiCard, { theme: props.theme, ...MewsUiCard.defaultProps })}
        ${(props) => stringifyRules(Card, { theme: props.theme })}
    }
    ${({ theme }) => generateCssSpacings({ theme })}
    ${(props) => generateButtonStyles(props.theme)}

    .embeddedServiceSidebarMinimizedDefaultUI .minimizedText {
        display: none !important;
    }
    .embeddedServiceSidebarMinimizedDefaultUI {
        width: auto !important;
        min-width: 0 !important;
    }
`;
export default () => globalStyles;
